import i18next from 'i18next'

export const ROUTINE_REMINDER_FREQUENCIES = [
  {
    value: 'HOURLY',
    name: 'routines_reminder.hour',
    plural_name: 'routines_reminder.hours',
  },
  {
    value: 'DAILY',
    name: 'routines_reminder.day',
    plural_name: 'routines_reminder.days',
  },
  {
    value: 'WEEKLY',
    name: 'routines_reminder.week',
    plural_name: 'routines_reminder.weeks',
  },
  {
    value: 'MONTHLY',
    name: 'routines_reminder.month',
    plural_name: 'routines_reminder.months',
  },
  {
    value: 'YEARLY',
    name: 'routines_reminder.year',
    plural_name: 'routines_reminder.years',
  },
]

export const END_VALUES = {
  never: 'never',
  on: 'on',
}

export const FREQUENCY_TYPE = {
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
}

export const NOTIFICATION_TYPE = {
  PUSH: 'push',
  EMAIL: 'email',
}

function getWeekdayFirstLetter(weekday) {
  return weekday.substring(0, 1)
}

export const AVAILABLE_WEEKDAYS = [
  {
    text: getWeekdayFirstLetter(i18next.t('common.week_days.sunday')),
    value: 'SU',
  },
  {
    text: getWeekdayFirstLetter(i18next.t('common.week_days.monday')),
    value: 'MO',
  },
  {
    text: getWeekdayFirstLetter(i18next.t('common.week_days.tuesday')),
    value: 'TU',
  },
  {
    text: getWeekdayFirstLetter(i18next.t('common.week_days.wednesday')),
    value: 'WE',
  },
  {
    text: getWeekdayFirstLetter(i18next.t('common.week_days.thursday')),
    value: 'TH',
  },
  {
    text: getWeekdayFirstLetter(i18next.t('common.week_days.friday')),
    value: 'FR',
  },
  {
    text: getWeekdayFirstLetter(i18next.t('common.week_days.saturday')),
    value: 'SA',
  },
]
